"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPointsOfSaleWithMenu = void 0;
class GetPointsOfSaleWithMenu {
    constructor(pointsOfSaleService) {
        this.pointsOfSaleService = pointsOfSaleService;
    }
    execute(request) {
        return this.pointsOfSaleService.getPointsOfSaleWithMenu(request);
    }
}
exports.GetPointsOfSaleWithMenu = GetPointsOfSaleWithMenu;
